import {AfterViewInit, Component, ElementRef, HostListener, Input, OnInit} from '@angular/core';
import {properties} from "../../../../../../environments/properties";

@Component({
    selector: 'app-partner-card',
    templateUrl: './partner-card.component.html',
    styleUrls: ['./partner-card.component.scss']
})
export class PartnerCardComponent implements OnInit, AfterViewInit {

    @Input() partner: any;
    @Input() appHostURL: any;
    @Input() currentEnvironment: string;
    @Input() userInfo: any;
    @Input() banner: any;
    public sm = '575px';
    public md = '768px';
    public imagePath: string;
    scrWidth:any;
    viewPort = 'desktop';

    constructor(public elementRef: ElementRef) {
    }

    ngOnInit(): void {
        this.imagePath = properties.rewardsConfig.imagePath;
    }

    @HostListener('window:resize', ['$event'])
    getScreenSize(event?) {
        this.scrWidth = window.innerWidth;
        if(this.scrWidth >= 768) {
            this.viewPort = 'desktp';
        } else{
            this.viewPort = 'moobile';
        }
        const btnElement = this.elementRef.nativeElement.querySelector('.partner-image');
        if (btnElement) {
            btnElement.style.backgroundImage = this.getImageUrl(this.viewPort);
            btnElement.style.backgroundRepeat = 'no-repeat';
            btnElement.style.backgroundSize = '100% 100%';
        }
    }

    ngAfterViewInit() {
        const btnElement = this.elementRef.nativeElement.querySelector('.partner-image');
        if (btnElement) {
            btnElement.style.backgroundImage = this.getImageUrl(this.viewPort);
            btnElement.style.backgroundRepeat = 'no-repeat';
            btnElement.style.backgroundSize = '100% 100%';
        }
    }

    public getImageUrl(viewport: string): string {
        let imageRef = '';
        let imgPath = '';
        if (this.partner && this.partner.bgImgFileReference) {
            const modifiedImagePath = this.partner.bgImgFileReference.replace(/\$.*/, '');
            if(viewport === 'desktop') {
                imgPath = '?$partner-cards-desktop$&defaultImage=Not_Available';
            } else {
                imgPath = '?$partner-cards-tablet$&defaultImage=Not_Available';
            }

            imageRef = 'url(' + modifiedImagePath + imgPath + ')'
        }
        return imageRef;
    }

    public openPartnerDetailPage(event) {
        if (window['AB'] && window['AB']['DATALAYER']) {
            const linkName = event.target.classList.contains('button-container') || event.target.classList.contains('button-display') ? `:${this.partner.ctaText?.toLowerCase()?.replace(/ /g, '-')}` : '';
            window['AB']['DATALAYER'].setLinkClickEvents(`for-u-partner-offers|${this.partner.title?.toLowerCase()?.replace(/ /g, '-')}${linkName}`, true);
        }
        window.open(this.partner.ctaLink, '_blank');
    }


}
